import dayjs from 'dayjs';

const currentDay = dayjs().format('YYYY.MM.DD');

export const countingPassedDays = (dateQuestion: string) => {
  const questionDate = dateQuestion.substring(0, 10);
  const diff = Math.floor(+(Date.parse(currentDay) - Date.parse(questionDate)) / 86400000);
  return diff;
};
